import React, { useEffect, useState } from "react";
import "../../css_files/Customer/CustomerEnquiryDetail.css";
import axiosInstance from "../../api";
import CloseForm from "../Master/CloseForm";

function CustomerEnquiryDetail({ customerEnquiryId, setShowEnquiryDetail }) {
  const [customerEnquiryDetail, setCustomerEnquiryDetail] = useState(null);
  useEffect(() => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/CustomerEnquiries/${customerEnquiryId}`
      )
      .then((res) => {
        Promise.all([
          getStateById(res.data.shippingAddress.state),
          getCityById(res.data.shippingAddress.city),
          getStateById(res.data.billingAddress.state),
          getCityById(res.data.billingAddress.city),
        ]).then((resp) => {
          setCustomerEnquiryDetail({
            ...res.data,
            shippingAddress: {
              ...res.data.shippingAddress,
              stateName: resp[0],
              cityName: resp[1],
            },
            billingAddress: {
              ...res.data.billingAddress,
              stateName: resp[2],
              cityName: resp[3],
            },
          });
        });
      })
      .catch(console.log);
  }, [customerEnquiryId]);

  function getStateById(stateId) {
    return axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/StateandCities/GetSingleStateById/${stateId}`
      )
      .then((res) => res.data.name)
      .catch((err) => "");
  }

  function getCityById(cityId) {
    return axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/StateandCities/GetSingleCityById/${cityId}`
      )
      .then((res) => res.data.name)
      .catch((err) => "");
  }

  return (
    <section className="customer-enquiry-detail">
      <div>
        <h1>Customer Enquiry Details</h1>
        <p>
          <strong>Company/Organization Name: </strong>
          {customerEnquiryDetail?.companyName}
        </p>
        <p>
          <strong>Shipping Addresss: </strong>
          {customerEnquiryDetail?.shippingAddress?.addressType} |{" "}
          {customerEnquiryDetail?.shippingAddress?.addressLine1},{" "}
          {customerEnquiryDetail?.shippingAddress?.addressLine2},{" "}
          {customerEnquiryDetail?.shippingAddress?.cityName},{" "}
          {customerEnquiryDetail?.shippingAddress?.stateName},{" "}
          {customerEnquiryDetail?.shippingAddress?.country},{" "}
          {customerEnquiryDetail?.shippingAddress?.pincode}
        </p>
        <p>
          <strong>Billing Addresss: </strong>
          {customerEnquiryDetail?.billingAddress?.addressType} |{" "}
          {customerEnquiryDetail?.billingAddress?.addressLine1},{" "}
          {customerEnquiryDetail?.billingAddress?.addressLine2},{" "}
          {customerEnquiryDetail?.billingAddress?.cityName},{" "}
          {customerEnquiryDetail?.billingAddress?.stateName},{" "}
          {customerEnquiryDetail?.billingAddress?.country},{" "}
          {customerEnquiryDetail?.billingAddress?.pincode}
        </p>
        <p>
          <strong>Customer Boiler: </strong>
          {customerEnquiryDetail?.boiler?.head},{" "}
          {customerEnquiryDetail?.boiler?.series}
        </p>
        <p>
          <strong>Customer Name: </strong>
          {customerEnquiryDetail?.customer?.salutation}{" "}
          {customerEnquiryDetail?.customer?.name}
        </p>
        <p>
          <strong>Customer Email: </strong>
          {customerEnquiryDetail?.customer?.email}
        </p>
        <p>
          <strong>Customer Phone Number: </strong>
          {customerEnquiryDetail?.customer?.phoneNumber}
        </p>
        <p>
          <strong>Customer Designation: </strong>
          {customerEnquiryDetail?.customer?.designation}
        </p>
        <p>
          <strong>Enquiry Type: </strong>
          {customerEnquiryDetail?.enquiryType}
        </p>
        <p>
          <strong>Enquiry Date: </strong>
          {new Date(customerEnquiryDetail?.enquiryDate).toDateString()}
        </p>
        <p>
          <strong>Priority: </strong>
          {customerEnquiryDetail?.priority}
        </p>
        <p>
          <strong>
            {customerEnquiryDetail?.enquiryType === "Service"
              ? "Services"
              : customerEnquiryDetail?.enquiryType}{" "}
            Looking For:
          </strong>{" "}
          {customerEnquiryDetail?.lookingFor}
        </p>
        <CloseForm close={setShowEnquiryDetail} />
      </div>
    </section>
  );
}

export default CustomerEnquiryDetail;
